import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import {
  Paper,
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import { SelectIcon } from "App/Assets";
import { useSearchDatatables } from "App/hooks";
import {
  DatatablesFooter,
  IconButtonDatatable,
  SearchInput,
} from "App/Component/ui";
import { getJenisLayananByRawatInap } from ".";

const useStyles = makeStyles({
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
    borderRadius: "8px",
  },
});

let PageSize = 10;

export default function ListTempatTidur({ formData, setFormData }) {
  const classes = useStyles();

  const order = "desc";
  const orderBy = "name";

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PageSize);

  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);

  const { data, length } = useSearchDatatables(rows, q, ["name"]);

  useEffect(() => {
    (async () => {
      const res = await getJenisLayananByRawatInap();
      if (res) {
        setRows(res);
      }
    })();
  }, []);

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <p className="fw-600 mb-1 mt-1">Tempat Tidur</p>
        <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
      </Grid>
      <TableContainer
        style={{
          overflow: "auto",
          maxHeight: "430px",
        }}
      >
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHead
            style={{
              border: "1px solid #fafafa",
            }}
          >
            <TableRow
              style={{
                backgroundColor: "#fff",
              }}
            >
              <TableCell align="left" width="50px">
                ACT
              </TableCell>
              <TableCell align="left">RAWAT INAP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}
                  >
                    <TableCell align="center">
                      <IconButtonDatatable
                        color="secondary"
                        aria-label="delete"
                        onClick={() => {
                          setFormData({
                            ...formData,
                            jenis_layanan_id: row.id,
                            jenis_layanan_name: row.name,
                          });
                        }}
                      >
                        <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                      </IconButtonDatatable>
                    </TableCell>
                    <TableCell align="left">{row?.name}</TableCell>
                  </TableRow>
                );
              })}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={2}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </Paper>
  );
}
